import { render } from "./AboutS9.vue?vue&type=template&id=579a83a4&scoped=true"
import script from "./AboutS9.vue?vue&type=script&lang=js"
export * from "./AboutS9.vue?vue&type=script&lang=js"

import "./AboutS9.vue?vue&type=style&index=0&id=579a83a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579a83a4"]])

export default __exports__